/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Plan_Choose_DescInputs */

const en_dr_plan_choose_desc = /** @type {(inputs: Dr_Plan_Choose_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite people with a link (no account needed), write ideas in silence, vote, then hand off to the wizard.`)
};

const id_dr_plan_choose_desc = /** @type {(inputs: Dr_Plan_Choose_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undang orang lewat tautan (tanpa akun), tulis ide diam-diam, vote, lalu serahkan ke wizard.`)
};

/**
* | output |
* | --- |
* | "Invite people with a link (no account needed), write ideas in silence, vote, then hand off to the wizard." |
*
* @param {Dr_Plan_Choose_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_plan_choose_desc = /** @type {((inputs?: Dr_Plan_Choose_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Plan_Choose_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_plan_choose_desc(inputs)
	return en_dr_plan_choose_desc(inputs)
});